import React from 'react';
import { createRoot } from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import App from './App';
import './index.css';

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
} else {
    // console.error('Failed to find the root element');
}

// Service Worker Registration for Push Notifications (Web only — disabled on Capacitor Native Mobile)
if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then(registration => {
                console.log('SW registered');
            })
            .catch(registrationError => {
                console.error('SW registration failed: ', registrationError);
            });
    });
}
